import React, { Component } from 'react';

import {BASE_URL_RECURSOS, BASE_URL_BOLETIN} from '../../../constants';


export default class DetalleMailing extends Component {

    state = {
        addNoticias: (this.props.recurso.length>2 ? this.props.recurso.slice(0,2) : this.props.recurso),
        colorBoletin: this.props.color,
        imageArrow: this.props.imagen,
        titulo: this.props.titulo,
        nBoletinCodigo: this.props.boletin
      }


    render() {

        return (     
            <div>
                <tr>
                    <td style={{background: '#ffffff', padding: '10px 20px'}}>
                        <table>
                            <tbody>
                                <tr hidden={((this.state.addNoticias.length>0)?false:true)}>
                                    <td>
                                        <ul style={{marginLeft: '-19px'}}>
                                            <li>
                                                <h3 style={{ fontSize:'1.8em', textAlign: 'left', fontWeight: 400, marginBottom: '0px', color: '#43434b', marginTop: 0}}>
                                                    { this.state.titulo}
                                                    {/* OPORTUNIDADES INTERNACIONALES */}
                                                </h3>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                                <br/>
                                {this.state.addNoticias.map((resource, index) => (
                                   
                                <span>
                                <tr className="imagen">
                                    <td  style={resource.sFondo===null? {backgroundColor: '#585c64'}:{  backgroundImage: `url("` + BASE_URL_RECURSOS + resource.sFondo + `")`}}>
                                        <table  className="shade" style={{  minWidth:'570px', minHeight: '300px', borderRadius: '4px'}}>
                                            <tbody>
                                                <tr style={{borderLeft: '5px solid ' + this.state.colorBoletin}}>
                                                    <td>
                                                        <p style={{color: '#fff', padding: '0px 20px'}}>
                                                            <br/>
                                                            <span style={{  borderLeft: '3px solid ' + this.state.colorBoletin, paddingLeft: '5px', fontWeight: 'bold', fontSize: '18px'}}>
                                                                NOTAS
                                                            </span>
                                                        </p>
                                                        <p style={{ color: '#fff', padding: '0px 20px', fontSize: '27px'}}>
                                                            <br/>
                                                            {resource.sTituloRecurso}
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr hidden={((this.state.addNoticias.length>0)?false:true)}>
                                    <td>
                                        <p style={{ color: '#43434b', lineHeight: '1.5', marginBottom: '0px'}}>
                                            {resource.sResumenRecurso}
                                        </p>
                                    </td>
                                </tr>
                                <tr hidden={((this.state.addNoticias.length>0)?false:true)} style={{textAlign: 'right'}}>
                                    <td style={{padding: '0px'}}>
                                        <table align="right">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <a target="_blank" href={BASE_URL_BOLETIN + '/' + this.state.nBoletinCodigo + '/' + ((this.state.addNoticias.length>0)?this.state.addNoticias[0].nRecursoCodigo:0)} style={{fontWeight: 'bold', paddingRight: '2px', color: '#d52b1e'}}>Más info &nbsp;</a>
                                                    </td>
                                                    <td>
                                                        <img src={this.state.imageArrow} />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br/>
                                        <br/>
                                        <br/>
                                    </td>
                                </tr>
                                </span>
                                ))}
                            </tbody>
                        </table>
                    </td>
                </tr>
            </div>
                   )
        ;
    }

}